import React, {Component, useContext, useEffect} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import InputsCheckbox from '../../../../components/inputs/inputs-checkbox';
import LabelContainer from '../../../../components/label-container';
import Blurred from '../../../../components/blurred';
import InputsCounter from '../../../../components/inputs/inputs-counter';
import DateTimeInput from '../../components/date-time-input/index';
import meetingsApi from '../../../../lib/meetings/meetings-api';
import ErrorContainer from '../../../../components/error-container';
import InputsText from '../../../../components/inputs/inputs-text';
import MediaHelper from '../../../../lib/helpers/media';
import _ from 'lodash';
import PopupContext from '../../../../context/context-popup';
import coWorkingApi from '../../../../lib/co-working/co-working-api';
import InputsDropdown from '../../../../components/inputs/inputs-dropdown';
import dayjs from 'dayjs';

const YourDetails = () => {
    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">{ title }</Container.Title>
                <Container.Text fontSize="16px">{ value }</Container.Text>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Details</Container.Text>
            </Container.Header>

            <Container.Content>
               <List gap="20px">
                <ButtonProceed onClick={() => window.location.href = `/mydmc/settings`}>Change Details</ButtonProceed>
               <Flex direction="column">
                    <Item title="Name" value={window.user?.name}/>
                    <Flex direction="row">
                        <Item title="Company" value="Company Name LTD"/>
                        <Item title="Role" value="Job Role"/>
                    </Flex>
                    <Item title="Email Address" value={window.user?.email}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={window.user?.user_profile?.tel_no}/>
                        <Item title="SAP Number" value="4654645654"/>
                    </Flex>
                </Flex>
               </List>
            </Container.Content>
        </Container>
    )
}

const Summary = ({
    costs = null,
    day,
}) => {
    const data = []

    if (costs !== null) {
        const items = costs?.session_items || costs?.saved_quote_line_items;

        items?.forEach((item, index) => {
            let cost = ``;

            if (item?.credits_used !== 0) {
                cost = `${item?.credits_used} credits` 
            }

            if (item?.total !== 0) {
                cost = `£${item?.total}`;
            }

            if (item?.credits_used > 0 && item?.total > 0) {
                cost = `£${item?.total} + ${item?.credits_used} credit(s)`
            }

            data.unshift([
                item?.quantity,
                costs?.hasOwnProperty('session_items') ? `${_.capitalize(item?.session)} Session` : item?.description,
                cost,
            ])
        })
    }

    return (
        <ContainerTable
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price/Credit(s)', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

class CoWorkingBookingEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            agree: false,
            spaces: [],
            space: null,
            errors: {},
            costs: null,
            params: {
                booker_type: 'App\\Models\\User',
                booker_id: window.user.id,
                discount: 0.00,
                day: null,
                morning_session: false,
                afternoon_session: false,
                co_working_space_id: null,
                no_attendees: 1,
                payment_type: 'bacs'
            }
        }
    }

    componentDidMount() {
        this.fetchSpaces();
        this.fetchBooking();
    }

    fetchSpaces() {
        coWorkingApi.getCoWorkingSpaces().then(({ data }) => {
            this.setState({ spaces: data })
        })
    }

    fetchBooking() {
        coWorkingApi.getCoWorkingBooking(this.props.id).then(({ data }) => {
            this.setState({ 
                costs: data?.saved_quote || data?.receipt,
                params: data,
            }, () => {
                this.fetchCoWorkingSpace();
            })
        })
    }

    fetchCoWorkingSpace() {
        coWorkingApi.getCoWorkingSpace(this.state.params?.co_working_space_id).then(({ data }) => {
            this.setState({ space: data })
        })
    }

    onChange(e, callback = () => {}) {
        const { name, value } = e.target;
        const params = { ...this.state.params }

        params[name] = value;

        this.setState({ params }, () => {
            callback();

            if (name === 'no_attendees') {
                this.getBookingCosts();
            }
        })
    }

    getBookingCosts = _.debounce(() => {
        coWorkingApi.getBookingCosts(this.state.params?.co_working_space_id, this.state.params).then(({ data }) => {
            this.setState({ costs: data });
        });
    }, 500, false);

    onSpaceSelect({ value }) {
        this.onMultipleChange({
            co_working_space_id: value
        }, () => {
            this.fetchSpace();
        })
    }

    createBooking() {
        coWorkingApi.updateCoWorkingBooking(this.state.params.id, this.state.params, (errors) => {
            this.setState({ errors })
        }).then(({ data }) => {
            window.location.href = `/mydmc/co-working/bookings/${data.id}`
        });
    }

    onMultipleChange(e, callback = () => {}) {
        let params = { ...this.state.params }

        params = {
            ...params,
            ...e
        }

        this.setState({ params }, callback);
    }

    onStartChange({ start, afternoon_session, morning_session }) {
        const props = {
            day: start.date,
            afternoon_session,
            morning_session,
        }

        this.onMultipleChange(props, () => {
            this.getBookingCosts();
        })
    }

    onAttendeesChange(value) {
        this.onChange({
            target: { name: 'no_attendees', value }
        })
    }

    getFeaturedImage() {
        const image = this.state.space?.content?.room_feature_image?.[0];

        if (image?.file_name === undefined) return '/images/office.png';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    getLocation() {
        const { name, address_one, address_two, address_post_code, address_city } = this.state?.space?.office_building || {
            name: '',
            address_one: '',
            address_two: '',
            address_post_code: '',
            address_city: ''
        };

        let string = [
            name,
            address_one,
            address_two,
            address_post_code,
            address_city
        ].filter(e => e !== undefined && e !== null && e?.length > 0);

        return string.join(', ');
    }

    render() {
        const featuredImage = this.getFeaturedImage();
        const location = this.getLocation();

        const quote = this.state.booking?.receipt || this.state.booking?.saved_quote;

        return (
            <Layout 
            theme="light"
            topLeft={<Welcome title={<Container.Text>
                <Row gap='10px' wrap>
                    Co-Working Booking: <Container.Text color="#FF6933">{ this.state.space?.name }: #{ this.state.params?.id }</Container.Text>
                </Row>
            </Container.Text>} subtitle={`Edit Your Co-Working Pass`}/>}
            topRight={
                <Row gap="20px">
                    <ButtonReturn onClick={() => window.location.href = `/mydmc/co-working`}>Cancel</ButtonReturn>
                </Row>
            }
        >
            <MinMaxLayout
                main={
                    <div className="booking-view">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" style={{ backgroundImage: `url('${featuredImage}')` }}></div>

                                        <LabelContainer label='Booking Type'>
                                            { this.state.space?.name }
                                        </LabelContainer>

                                        <LabelContainer label='Booking Location'>
                                            { location }
                                        </LabelContainer>

                                        <InputsDropdown
                                            label="Co-Working Space"
                                            value={this.state.params?.co_working_space_id}
                                            items={
                                                this.state.spaces?.map((space) => {
                                                    return {
                                                        label: space?.name,
                                                        value: space?.id
                                                    }
                                                })
                                            }
                                            onChange={this.onSpaceSelect.bind(this)}
                                        />

                                        <InputsCounter
                                            label="Number Of Attendees"
                                            min={0}
                                            max={this.state.space?.capacity_per_session}
                                            onChange={this.onAttendeesChange.bind(this)}
                                            value={this.state.params?.no_attendees}
                                            errors={this.state.errors?.no_attendees}
                                        />

                                        <LabelContainer label="Booking Date & Duration">
                                            <ErrorContainer errors={this.state.errors?.start}>
                                                <DateTimeInput
                                                    onChange={this.onStartChange.bind(this)}
                                                    space={this.state?.space}
                                                    value={{
                                                        start: this.state.params?.day,
                                                        afternoon_session: this.state.params?.afternoon_session,
                                                        morning_session: this.state.params?.morning_session,
                                                    }}
                                                    data={{
                                                        no_attendees: this.state.params?.no_attendees,
                                                    }}
                                                />
                                            </ErrorContainer>
                                        </LabelContainer>
                                    </List>
                                </Container.Content>
                            </Container>

                            <YourDetails/>
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        day={this.state.params?.day}
                                        costs={this.state.costs}
                                    />

                                    <Blurred toggled={this.state.params?.co_working_space_id === null}>
                                        <div className="agree-box">
                                            <InputsCheckbox
                                                text="I have read and agree to the booking terms and conditions"
                                                checked={this.state.agree}
                                                onChange={(e) => this.setState({ agree: e.value })}
                                            />
                                            <div className="agree-box__content">
                                                <div className="agree-box__details">
                                                    <List gap="5px">
                                                        { this.state.costs?.credits_available !== undefined && <Container.Text fontSize="16px">{ this.state.costs?.total_credits_available || 0} credits available</Container.Text> }
                                                        <div className="agree-box-details__detail">
                                                            <p>Credits Due</p>
                                                            <span>{ this.state?.costs?.credits_required_for_full_boo || 0 }</span>
                                                        </div>
                                                    </List>
                                                    <div className="agree-box-details__detail">
                                                        <p>BACS Due</p>
                                                        <span>£{ this.state?.costs?.total || 0 }</span>
                                                    </div>
                                                </div>

                                                <Blurred toggled={this.state.agree === false}>
                                                    <ButtonModify onClick={this.createBooking.bind(this)}>Complete your booking</ButtonModify>
                                                </Blurred>
                                            </div>
                                        </div>
                                    </Blurred>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={this.state.space?.booking_information}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" style={{ whiteSpace: 'pre' }}>
                                                +44 (0)1226 720 700

                                                bookings@barnsleydmc.co.uk

                                                DMC
                                                County Way
                                                Barnsley
                                                S70 2JW
                                                UK
                                            </Container.Text>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
        </Layout>    
        )
    }
}

const el = document.getElementById('coworking-booking-edit');

if (el) {
    ReactDOM.render(<CoWorkingBookingEdit id={el.getAttribute('data-id')}/> , el);
}
